import { Box, Card, Heading, Icon, Text } from '@zillow/constellation-10';
import { IconAwardRibbonFilled, IconMegaphoneFilled } from '@zillow/constellation-icons';

import { wizardTipCardRecipe } from './styles';

import type React from 'react';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <IconMegaphoneFilled />,
  children = null,
  header = null,
  isPremiumTip = false,
}: Props) => (
  <Card.Root tone="neutral" elevated={false} css={wizardTipCardRecipe.raw({ isPremium: isPremiumTip })}>
    <Card.Body>
      <Box css={{ marginBottom: '400' }}>
        {isPremiumTip ? (
          <>
            <Icon
              render={<IconAwardRibbonFilled />}
              size="sm"
              css={{ color: 'icon.accent.brand.hero', verticalAlign: 'middle' }}
            />
            <Text textStyle="body-sm-bold" css={{ color: 'text.accent.brand.hero' }} asChild>
              <span> Premium</span>
            </Text>
          </>
        ) : (
          <Icon render={icon} size="xl" css={{ color: 'icon.subtle' }} />
        )}
      </Box>

      {header && (
        <Box css={{ marginBottom: '400' }}>
          <Heading level={6} id="tip-title">
            {header}
          </Heading>
        </Box>
      )}

      {children}
    </Card.Body>
  </Card.Root>
);

export { WizardTipCard };
